import React, { useContext, ReactNode } from 'react';
import { Route } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import Overall from './Overall';
import Streaming from './Streaming';
import Download from './Download';

import { EntityContext } from 'context/entityContext';
import TopicFilters from 'components/TopicFilters/TopicFilters';

import { performanceSubTopics } from 'topics';
import { IEntityPageComponentProps } from 'pages/Entity/shared';
import Playlist from './Playlist';
import PriorityPlaylist from './PriorityPlaylist';

const Performance: React.FC<IEntityPageComponentProps> = (props) => {
  const { match, pathPrefix } = props;
  const { entityId } = match.params;
  const { compareMode, topic } = useContext(EntityContext);

  return (
    <>
      <SubNavigation topic="performance" variants={performanceSubTopics} />
      <TopicFilters topic={topic[1] || topic[0]} compareMode={compareMode} />
      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/performance/all`}
        render={(): ReactNode => <Overall />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/performance/streaming`}
        render={(): ReactNode => <Streaming />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/performance/download`}
        render={(): ReactNode => <Download />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/performance/playlist`}
        render={(): ReactNode => <Playlist />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/performance/playlist/priority`}
        render={(): ReactNode => <PriorityPlaylist />}
      />
    </>
  );
};

export default Performance;
